import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NgForm } from "@angular/forms";
import { UpdateBuyerData, UpdateBuyerAdditionalData } from "@app/models/dataUpdateMyClients.model";
import { Department } from "@app/models/department.model";
import { MyClientsReSignEmailFauRequestModel } from "@app/models/myClientsReSingEmailRequest.model";
import { MyClientsReSingRespondeModel } from "@app/models/myClientsReSingResponse.model";
import { HelperService } from "@app/services/helper.service";
import { ModalService } from "@app/services/modal.service";
import { MyClientsService } from "@app/services/my-clients.service";
import { SubjectService } from "@app/services/subject.service";
import { environment } from "../../../../environments/environment";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";

@Component({
  selector: "app-data-update-form",
  templateUrl: "./data-update-form.component.html",
  styleUrls: ["./data-update-form.component.scss"],
})
export class DataUpdateFormComponent implements OnInit, OnDestroy {

  @Output() cancel = new EventEmitter<void>();

  private modalType: "success" | "error" | null;
  public additionalEmail: boolean = false;
  public additionalCellphone: boolean = false;
  public departments: Array<Department>;
  public isAddressValid: boolean = false;
  public isTermAccepted: boolean = false;
  public updateBuyerDataForm: UpdateBuyerData = new UpdateBuyerData();
  public updateBuyerAdditionalData: UpdateBuyerAdditionalData = new UpdateBuyerAdditionalData();
  public dataClientReSign: MyClientsReSingRespondeModel;
  public validPattern: boolean = false;
  
  private readonly unsubscribe$: Subject<void> = new Subject<void>();

  public documentTypesOptions = [
    {
      LABEL: "CEDULA DE CIUDADANIA",
      ID: "C",
      VALUE: "C.C. CÉDULA DE CIUDADANIA",
    },
    {
      LABEL: "CEDULA DE EXTRANJERIA",
      ID: "E",
      VALUE: "C.E. CÉDULA DE EXTRANJERIA",
    },
  ];

  constructor(
    public helper: HelperService,
    public modal: ModalService,
    private subjectStore: SubjectService,
    private myClientService: MyClientsService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit() {
    this.departments = this.helper.citiesDepartment;
    this.subjectStore.dataClientReSign$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(this.setDataClientReSingSubs.bind(this));
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  sendDataUpdate() {
    this.spinner.show();
    const payload = this.createRequestPayload();
    console.log(payload);
    this.myClientService.sendEmailReSignFau(payload).subscribe(
      (response) => {
        console.log(response);
        this.spinner.hide();
        this.openModalSuccess();
      },
      (error: any) => {
        this.spinner.hide();
        this.openModalError();
      }
    );
  }

  openModalSuccess() {
    this.modal.show("generalTemplate", {
      title: "¡Solicitud enviada!",
      icon: "icon-done.svg",
      mainSubtitle:
        "Hemos enviado al correo electrónico de su comprador el link para finalizar la actualización de datos.",
      secondarySubtitle: "Recuerde que este expira en 3 horas.",
      buttonName: "Aceptar",
    });

    this.modalType = "success";
  }

  openModalError() {
    this.modal.show("generalTemplate", {
      title: "¡Lo sentimos!",
      icon: "icon-error.svg",
      mainSubtitle:
        "Su comprador presenta una novedad en su cupo, por favor comuníquese a nuestro centro de experiencia PBX:",
      secondarySubtitle:
        "Línea nacional: 018000-946-969 <br> Línea en Bogotá: (601) 353 43 24",
      buttonName: "Aceptar",
    });

    this.modalType = "error";
  }

  getDocumentSelector(document: any) {
    this.validPattern = document.patternValid;
    if (document && document.documentType && document.document) {
      this.updateBuyerAdditionalData.legalRepresentativeDocumentNumber = document.patternValid ? document.document : '';
      this.updateBuyerAdditionalData.legalRepresentativeDocumentType = document.documentType;
    }
  }

  setAddressValid(value: boolean) {
    this.isAddressValid = value;
  }

  setAcceptTerms(value: boolean) {
    this.isTermAccepted = value;
  }

  addEmail() {
    this.additionalEmail = true;
  }

  addCellphone() {
    this.additionalCellphone = true;
  }

  deleteEmail() {
    this.additionalEmail = false;
    this.updateBuyerDataForm.email2 = "";
  }

  deleteCellphone() {
    this.additionalCellphone = false;
    this.updateBuyerDataForm.cellphone2 = "";
  }

  copyLegalRepToContactData() {
    const {
      legalRepresentativeNames: contactNames,
      legalRepresentativeLastNames: contactLastNames,
      legalRepresentativeEmail: contactEmail,
      legalRepresentativeCellphone: contactCellphone
    } = this.updateBuyerAdditionalData;
   
    Object.assign(this.updateBuyerAdditionalData, {
      contactNames,
      contactLastNames,
      contactEmail,
      contactCellphone
    });
  }

  isUpdateDisabled(dataUpdateForm: NgForm): boolean {
    return (
      !dataUpdateForm.valid ||
      !this.isAddressValid ||
      !this.isTermAccepted ||
      !(
        this.updateBuyerDataForm.modeWP ||
        this.updateBuyerDataForm.modeEmail ||
        this.updateBuyerDataForm.modeSMS ||
        this.updateBuyerDataForm.modePhone
      )
    );
  }

  setDataClientReSingSubs(response: MyClientsReSingRespondeModel) {
    this.dataClientReSign = response;
  }

  createRequestPayload(): MyClientsReSignEmailFauRequestModel {
    const payloadRequest = new MyClientsReSignEmailFauRequestModel();
    const {
      city,
      cellphone1,
      cellphone2,
      email1,
      email2,
      modeWP,
      expeditionDate,
      modeEmail,
      modeSMS,
      modePhone,
    } = this.updateBuyerDataForm;
    const {
      documento,
      radicacion,
      id_unico,
      cupo_comprador,
      nombre,
      tipo_documento,
      formulario
    } = this.dataClientReSign;
    const dataAuth = JSON.parse(sessionStorage.getItem("user") || '').userInfo;
    const uniqueId = `${documento}${new Date().getTime()}`;
    const contactChannelsParams = new URLSearchParams(UpdateBuyerData.toRequest(this.updateBuyerDataForm)).toString() + '&'; 
    const receivedParams = formulario ?
      new URLSearchParams(UpdateBuyerAdditionalData.toRequest(this.updateBuyerAdditionalData)).toString() + '&'
      : '';
    
    payloadRequest.id = uniqueId;
    payloadRequest.idOld = id_unico ? id_unico : null;
    payloadRequest.radicacion = radicacion;
    payloadRequest.direccion = this.formatAddress();
    payloadRequest.ciudad = city;
    payloadRequest.cupoComprador = cupo_comprador;
    payloadRequest.documento = documento;
    payloadRequest.documentoAfiliado = Number(dataAuth.DOCUMENTO);
    payloadRequest.nombreComprador = nombre;
    payloadRequest.tipoDoc = tipo_documento;
    payloadRequest.tipoDocAfiliado = dataAuth.TIPO_DOCUMENTO;
    payloadRequest.correosComprador.push(email1);
    payloadRequest.celulares.push(cellphone1);
    payloadRequest.token = dataAuth.TOKEN_ALTERNO;
    payloadRequest.urlCupo = `${environment.urlApi}/pr_solicitud_cupo?${contactChannelsParams}${receivedParams}`;
    payloadRequest.urlLanding = `${environment.electronicSignatureUrl}?idUnico=${uniqueId}&refirma=true`;
    payloadRequest.whatsApp = modeWP || false;
    payloadRequest.sms = modeSMS || false;
    payloadRequest.llamada = modePhone || false;
    payloadRequest.correoElectronico = modeEmail || false;
    payloadRequest.fecha_expedicion = moment(expeditionDate).format('YYYYMMDD');
    payloadRequest.usuario = dataAuth.USUARIO;

    if (cellphone2) payloadRequest.celulares.push(cellphone2);
    if (email2) payloadRequest.correosComprador.push(email2);

    return payloadRequest;
  }

  formatAddress(): string {
    if (this.updateBuyerDataForm.addressType) {
      const {
        addressType,
        addressFirst,
        addressSecond,
        addressThird,
        addressOther,
      } = this.updateBuyerDataForm;
      if (addressType !== "Otra") return `${addressType} ${addressFirst} ${addressSecond} ${addressThird}`;
      else return `${addressOther}`;
    }
    else return '';
  }

  onCancel() {
    this.cancel.emit();
  }

  handleCloseModal($event: boolean) {
    if (this.modalType == "success" && $event) {
      this.modalType = null;
      this.onCancel();
    }
  }

  onBlur($event: any) {
    $event.currentTarget.value = $event.currentTarget.value.trim();
  }
}
